






























import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import uuid from 'uuid/v4';

@Component({})
export default class SelectFieldWidget extends Vue {

  @Inject() public $validator: any;

  @Prop(Array) public inputOptions!: any[];
  @Prop() public initialSelected!: any;
  @Prop(String) public title!: string;
  @Prop(String) public inputName!: string;
  @Prop({ type: String, default: 'description' }) public displayField!: string;
  @Prop({ type: Boolean, default: true }) public selectOnTab!: boolean;
  @Prop(String) public staticInputId!: string;
  @Prop(String) public valueField!: string;
  @Prop(Boolean) public isRequired!: boolean;
  @Prop(Boolean) public choose!: boolean;
  @Prop(Boolean) public isDisabled!: boolean;
  @Prop(Boolean) public unSelectFirst!: boolean;
  @Prop(Boolean) public showWarningIcon!: boolean;
  @Prop(Boolean) public isSearchable!: boolean;
  @Prop(String) public emptyDescription!: string;
  @Prop(String) public reducerIndex!: string;
  @Prop(Boolean) public clearField!: boolean;
  @Prop(Boolean) public multiple!: boolean;
  @Prop(Boolean) public clearAble!: boolean;
  @Prop({ type: String, default: 'payrollForm' }) public formName!: string;

  private inputModel: any = {};
  private selectOptions: any[] = [];
  private inputId: string = '';
  private htmlName: string = '';
  private emptyDesc: string = '';

  public created() {
    this.$validator.extend('isSelected', { // validation for v-select is selected
      getMessage: (field: any) => this.$t('missingSelection', { field }),
      validate: (vSelect: any) => {
        return Object.keys(vSelect).length > 0 && vSelect.constructor === Object
          && vSelect[this.displayField] !== this.emptyDesc;
      },
    });

    this.inputId = this.staticInputId || 'input' + uuid();
    this.htmlName = this.inputName || this.$t(this.title).toString();
    if (this.formName && !this.staticInputId) {
      this.inputId = this.formName + '.' + this.inputId;
    }
  }

  public mounted() {
    this.emptyDesc = '(' + this.$t(this.emptyDescription || (this.isRequired || this.choose ? 'choose' : 'all')) + ')';

    const emptyOption: any = {};
    emptyOption[this.displayField] = this.emptyDesc;
    this.selectOptions = [emptyOption, ...this.inputOptions];

    if (this.initialSelected) {
      this.inputModel = this.initialSelected;
    } else if (this.inputOptions.length > 0 && !this.unSelectFirst) {
      this.inputModel = this.inputOptions[0];
    } else {
      this.inputModel = this.selectOptions[0];
    }
  }

  get validators(): any {
    if (this.isRequired) {
      return {
        isSelected: true,
      };
    }
    return null;
  }

  public onChange(selected: any): void {
    if (typeof selected === 'string' && !!selected && selected.length > 0) {
      this.updateModel(selected);
    } else if (Object.keys(selected).length > 0) {
      this.updateModel(selected);
    }
  }

  public updateModel(selected: any) {
    this.inputModel = selected;
    this.$emit('input', selected[this.displayField] === this.emptyDesc ? null : selected);
  }

  public updateNull($event: any): void {
    this.inputModel = this.selectOptions[0];
    this.$emit('input', this.inputModel);
  }

  public getLabel(option: any): any {
    if (option && typeof option === 'object') {
      if (this.displayField && option.hasOwnProperty(this.displayField) && option[this.displayField]) {
        return option[this.displayField];
      }
    }
    return '';
  }
}
